import pagesNames from "../../constants/pages-names"

const ourJourneyPageData = {
    header : {
        image : {
            name : "journey.jpg",
            alt : "Our Joureny wallpaper",
        }
    },
    mainTitle : "Our ESG Journey",
    sectionOne : {
        borderBox : {
            title : "Target Operating Model (TOM) Recommendations",
            subtitle : "Supported by Target Operating Model (TOM) recommendations to deliver – modelled on leading global practices on ESG",
        },
        cards : [
            {
                title : "Governance and leadership"
            },
            {
                title : "Risk management"
            },
            {
                title : "ESG Reporting and KPIs"
            },
            {
                title : "Sustainable finance"
            },
            {
                title : "Operations"
            },
            {
                title : "External engagement"
            },
        ]
    },
    timeLine : {
        title : "SAB’s ESG journey: the long game",
        headers : ["2022-23", "2023-25", "2025-30", "2030-40", "2040 & beyond.. "],
        tabs : [
            {
                title : "Plant One Million trees & Partner with SGI",
                subtitle : "Build Capability",
                list : [
                    {
                        text : "Setup Sustainable Finance Framework",
                        important : false,
                    },
                    {
                        text : "Roll out Sustainable finance & investment propositions",
                        important : false,
                    },
                    {
                        text : "Build capability across all departments of the bank",
                        important : true,
                    },
                    {
                        text : "Partner with third parties to measure baseline",
                        important : false,
                    },
                    {
                        text : "Announce strategy and ambitions",
                        important : false,
                    },
                    {
                        text : "Run awareness sessions for clients",
                        important : false,
                    },
                    {
                        text : "Roll out Transition Risk Questionnaires (TRQ)",
                        important : false,
                    },
                ],
                image : {
                    name : "img-1.jpg",
                    alt : "Tab 1"
                }
            },
            {
                title : "SF Financing & Investments of SAR 34 Bil",
                subtitle : "Grow & Capture Market share",
                list : [
                    {
                        text : "Complete Scenario Analysis",
                        important : false,
                    },
                    {
                        text : "Net Zero based on SBTi recommendations",
                        important : false,
                    },
                    {
                        text : "Further develop a comprehensive SF solutions",
                        important : false,
                    },
                    {
                        text : "Aggressively finance ESG solutions",
                        important : true,
                    },
                    {
                        text : "Collect Data from TEQ’s",
                        important : false,
                    },
                    {
                        text : "Build Risk policies",
                        important : false,
                    },
                    {
                        text : "Penetrate new & emerging sectors",
                        important : false,
                    },
                    {
                        text : "Report based on TCFD recommendations",
                        important : false,
                    },
                    {
                        text : "Thought leadership through external publications",
                        important : false,
                    },
                ],
                image : {
                    name : "img-2.jpg",
                    alt : "Tab 2"
                }
            },
            {
                title : "Achieve Key Net Zero milestones",
                subtitle : "Embed Risk Policies",
                list : [
                    {
                        text : "Publicly disclose financed carbon emissions",
                        important : false,
                    },
                    {
                        text : "Integrate ESG into our businesses and functions",
                        important : true,
                    },
                    {
                        text : "Review CRR framework to include ESG metrics",
                        important : false,
                    },
                    {
                        text : "Mark a significant Sustainable Financing milestone",
                        important : false,
                    },
                    {
                        text : "Signup for GFANZ and other international ESG leadership bodies",
                        important : false,
                    },
                    {
                        text : "Market recognition for being an ESG leader",
                        important : false,
                    },
                ],
                image : {
                    name : "img-3.jpg",
                    alt : "Tab 3"
                }
            },
            {
                title : "Achieve Net Zero in Operations",
                subtitle : "Reduce footprint",
                list : [
                    {
                        text : "Achieve Net Zero in Operations",
                        important : true,
                    },
                    {
                        text : "Implement reduction pathways away from high carbon emitting sectors and customers",
                        important : false,
                    },
                    {
                        text : "Implement internal carbon price",
                        important : false,
                    },
                    // {
                    //     text : "Disclose financed emissions for the banks portfolio",
                    //     important : false,
                    // },
                ],
                image : {
                    name : "img-4.jpg",
                    alt : "Tab 4"
                }
            },
            {
                title : "Measure, Report, Communicate and Lead",
                subtitle : "",
                list : [
                    {
                        text : "Continue the ambition to decarbonise the financed portfolio",
                        important : false,
                    },
                    {
                        text : "Consistently adapt to international disclosure standards",
                        important : false,
                    },
                    {
                        text : "Set annual milestones to demonstrate progress against ambition",
                        important : false,
                    },
                    {
                        text : "Achieve Net Zero in our Financed Emissions by 2060 or before",
                        important : true,
                    },
                ],
                image : {
                    name : "img-5.jpg",
                    alt : "Tab 5"
                }
            },
        ],
        
    },
    flexViewSection : [
        {
            image : {
                name : "img-2.jpg",
                alt : "Light Cross the trees",
            },
            title : "Social Impact",
            subtitle : "Play a leading role to shape an inclusive and diverse society, positively impacting our stakeholders",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
        {
            image : {
                name : "img-5.jpg",
                alt : "a person using a laptop",
            },
            title : "Overarching Goal",
            subtitle : "Commitment towards a high standard of governance, driving integrity and responsibility in all decision-making.",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
        {
            image : {
                name : "img-4.jpg",
                alt : "A woman helps a child",
            },
            title : "Sustainability in Our Operations",
            subtitle : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
    ]
}

export default ourJourneyPageData